import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SignIn from './pages/SignIn';
import Dashboard from './pages/Dashboard';
import CashFlow from './pages/CashFlow';
import UsersPage from './pages/UsersList';
import StoresPage from './pages/StoresList';
import ResetPasswordSimple from './pages/resetPassword';
import InventoryPage from './pages/InventoryList';
import InventoryEntriesPage from './pages/InventoryEntries';
import ReportsPage from './pages/Reports';
import Layout from './pages/Layout';
import InventoryCategoryPage from './pages/inventoryCategoryList';
import SettingsPage from './pages/SettingsPage';
import { useEffect } from 'react';

export default function App() {
  const hostname = window.location.hostname;
  console.log("Ashmin testing for hostname : ",hostname)
   useEffect(() => {
    const hostname = window.location.hostname;

    if (hostname === 'inventory.fescafe.in') {
      document.title = 'FES Inventory Portal';
    } else if (hostname === 'records.fescafe.in') {
      document.title = 'FES Store Portal';
    } else {
      document.title = 'FES Cafe';
    }
  }, []);
  if (hostname === 'inventory.fescafe.in') {
    // Only allow inventory-related routes plus sign-in/reset password
    return (
      <Router>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/reset-password" element={<ResetPasswordSimple />} />

          <Route
            path="/inventory/products"
            element={
              <Layout>
                <InventoryPage />
              </Layout>
            }
          />
          <Route
            path="/inventory/entries"
            element={
              <Layout>
                <InventoryEntriesPage />
              </Layout>
            }
          />
          <Route
            path="/categories"
            element={
              <Layout>
                <InventoryCategoryPage />
              </Layout>
            }
          />

          {/* Redirect any other route to /inventory/products */}
          <Route path="*" element={<Navigate to="/inventory/products" replace />} />
        </Routes>
      </Router>
    );
  } else if (hostname === 'records.fescafe.in') {
    // For records.fescafe.in, allow all routes except any /inventory/* routes
    // Redirect inventory paths elsewhere

    return (
      <Router>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/reset-password" element={<ResetPasswordSimple />} />

          <Route
            path="/dashboard"
            element={
              <Layout>
                <Dashboard />
              </Layout>
            }
          />
          <Route
            path="/cashflow"
            element={
              <Layout>
                <CashFlow />
              </Layout>
            }
          />
          <Route
            path="/users"
            element={
              <Layout>
                <UsersPage />
              </Layout>
            }
          />
          <Route
            path="/stores"
            element={
              <Layout>
                <StoresPage />
              </Layout>
            }
          />
          <Route
            path="/reports"
            element={
              <Layout>
                <ReportsPage />
              </Layout>
            }
          />
          <Route
            path="/settings"
            element={
              <Layout>
                <SettingsPage />
              </Layout>
            }
          />
          <Route
            path="/categories"
            element={
              <Layout>
                <InventoryCategoryPage />
              </Layout>
            }
          />

          {/* Redirect inventory routes anywhere else or home */}
          <Route
            path="/inventory/*"
            element={<Navigate to="/dashboard" replace />}
          />

          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    );
  } else {
    // Default fallback for other domains, allow all routes
    return (
      <Router>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/reset-password" element={<ResetPasswordSimple />} />

          <Route
            path="/dashboard"
            element={
              <Layout>
                <Dashboard />
              </Layout>
            }
          />
          <Route
            path="/cashflow"
            element={
              <Layout>
                <CashFlow />
              </Layout>
            }
          />
          <Route
            path="/users"
            element={
              <Layout>
                <UsersPage />
              </Layout>
            }
          />
          <Route
            path="/stores"
            element={
              <Layout>
                <StoresPage />
              </Layout>
            }
          />
          <Route
            path="/inventory/products"
            element={
              <Layout>
                <InventoryPage />
              </Layout>
            }
          />
          <Route
            path="/inventory/entries"
            element={
              <Layout>
                <InventoryEntriesPage />
              </Layout>
            }
          />
          <Route
            path="/reports"
            element={
              <Layout>
                <ReportsPage />
              </Layout>
            }
          />
          <Route
            path="/categories"
            element={
              <Layout>
                <InventoryCategoryPage />
              </Layout>
            }
          />
          <Route
            path="/settings"
            element={
              <Layout>
                <SettingsPage />
              </Layout>
            }
          />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    );
  }
}
